import React from 'react';
import { motion } from 'framer-motion';
import { FaLock, FaHome, FaUserShield } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import TopBar from '../components/Layout/TopBar';

const RGPD = () => {
  return (
    <div className="min-h-screen bg-[#001B56]">
      <TopBar />
      <div className="sticky top-4 z-50 flex flex-col items-center w-full">
        <div className="relative w-[90vw] max-w-2xl">
          <Navbar />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[#00238D] shadow-lg p-8 rounded-lg"
        >
          <div className="flex items-center gap-3 mb-8">
            <FaUserShield className="text-3xl text-green-600" />
            <h1 className="text-3xl font-bold">Protection des Données Personnelles (RGPD)</h1>
          </div>

          <div className="prose max-w-none">
            <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
              <div className="flex items-center gap-3 mb-4">
                <FaLock className="text-2xl text-green-600" />
                <h2 className="text-xl font-bold text-green-800">Votre vie privée est importante</h2>
              </div>
              <p className="text-green-700">
                L'EFAFC s'engage à protéger vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
              </p>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">1. Responsable du traitement</h2>
            <p className="mb-6">
              Le responsable du traitement des données est l'Entente Feignies Aulnoye Football Club (EFAFC), 
              représenté par son président. Pour toute question relative à la protection de vos données, 
              vous pouvez nous contacter à : <strong>contact@efafc.fr</strong>
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">2. Données collectées</h2>
            <div className="mb-6">
              <p className="mb-4">Nous collectons les données suivantes :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Données d'identification :</strong> nom, prénom, adresse email, pseudo</li>
                <li><strong>Données de connexion :</strong> adresse IP, logs de connexion</li>
                <li><strong>Données d'activité :</strong> scores aux jeux, badges obtenus, messages postés</li>
                <li><strong>Données facultatives :</strong> photo de profil, préférences</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">3. Finalités du traitement</h2>
            <div className="mb-6">
              <p className="mb-4">Vos données sont utilisées pour :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Gérer votre compte utilisateur et votre profil</li>
                <li>Vous permettre de participer aux jeux et activités de la Fan Zone</li>
                <li>Afficher vos contributions sur le mur des supporters</li>
                <li>Vous envoyer des notifications liées à vos activités</li>
                <li>Améliorer nos services et l'expérience utilisateur</li>
                <li>Respecter nos obligations légales</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">4. Base légale</h2>
            <div className="mb-6">
              <p className="mb-4">Le traitement de vos données repose sur :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Votre consentement</strong> pour les newsletters et communications marketing</li>
                <li><strong>L'exécution du contrat</strong> pour la fourniture de nos services</li>
                <li><strong>L'intérêt légitime</strong> pour l'amélioration de nos services</li>
                <li><strong>L'obligation légale</strong> pour le respect de nos obligations</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">5. Durée de conservation</h2>
            <div className="mb-6">
              <p className="mb-4">Nous conservons vos données :</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Données de compte :</strong> tant que votre compte est actif + 3 ans après suppression</li>
                <li><strong>Données de jeux :</strong> 5 ans maximum pour les statistiques</li>
                <li><strong>Messages publics :</strong> tant qu'ils sont publiés sur le site</li>
                <li><strong>Logs techniques :</strong> 12 mois maximum</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">6. Vos droits</h2>
            <div className="mb-6">
              <p className="mb-4">Conformément au RGPD, vous disposez des droits suivants :</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-bold mb-2">Droit d'accès</h4>
                  <p className="text-sm text-white">Obtenir une copie de vos données personnelles</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-bold mb-2">Droit de rectification</h4>
                  <p className="text-sm text-white">Corriger vos données inexactes ou incomplètes</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-bold mb-2">Droit à l'effacement</h4>
                  <p className="text-sm text-white">Demander la suppression de vos données</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-bold mb-2">Droit à la portabilité</h4>
                  <p className="text-sm text-white">Récupérer vos données dans un format standard</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-bold mb-2">Droit d'opposition</h4>
                  <p className="text-sm text-white">Vous opposer au traitement de vos données</p>
                </div>
                <div className="border border-gray-200 rounded-lg p-4">
                  <h4 className="font-bold mb-2">Droit de limitation</h4>
                  <p className="text-sm text-white">Limiter le traitement de vos données</p>
                </div>
              </div>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">7. Exercer vos droits</h2>
            <div className="bg-[#001B56] border border-blue-200 rounded-lg p-6 mb-6">
              <p className="mb-4">
                Pour exercer vos droits, contactez-nous par email à : <strong>contact@efafc.fr</strong>
              </p>
              <p className="mb-4">
                Votre demande doit inclure :
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Une copie de votre pièce d'identité</li>
                <li>La précision du droit que vous souhaitez exercer</li>
                <li>L'adresse à laquelle vous souhaitez recevoir la réponse</li>
              </ul>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">8. Sécurité des données</h2>
            <p className="mb-6">
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données :
              chiffrement, contrôle d'accès, surveillance, sauvegarde et authentification sécurisée.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">9. Transferts de données</h2>
            <p className="mb-6">
              Vos données peuvent être traitées dans des pays situés en dehors de l'Union européenne, 
              notamment via les services Firebase de Google. Ces transferts sont encadrés par des garanties appropriées 
              conformément au RGPD.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">10. Réclamation</h2>
            <p className="mb-6">
              Si vous estimez que le traitement de vos données personnelles constitue une violation du RGPD, 
              vous avez le droit d'introduire une réclamation auprès de la CNIL : 
              <a href="https://www.cnil.fr" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
                www.cnil.fr
              </a>
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">11. Modification de la politique</h2>
            <p className="mb-6">
              Cette politique de protection des données peut être modifiée. 
              Nous vous informerons de toute modification importante par email ou via une notification sur le site.
            </p>

            <p className="text-sm text-white italic">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <FaHome />
              Retour à l'accueil
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RGPD;